import { render } from "./StaffingMatrix.vue?vue&type=template&id=6ffab66e&scoped=true&ts=true"
import script from "./StaffingMatrix.vue?vue&type=script&lang=ts"
export * from "./StaffingMatrix.vue?vue&type=script&lang=ts"

import "./StaffingMatrix.vue?vue&type=style&index=0&id=6ffab66e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffab66e"]])

export default __exports__